<template>
	<div class="card-form" :class="{ctaDone: ctaExists && ctaDone}">
		<div class="col-9 email-send desktop" v-if="ctaExists">
			<div class="container-content">
				<img src="https://img.qromo.io/img/icon-send-email.svg" alt="icon send email">
				<h2 v-if="ctaText">{{ ctaText }}</h2>
				<AppButton class="mt-20" :text="getString('go_back')" outline @click="$emit('cta-click')" />
			</div>
		</div>
		<div class="col-3 pattern">
			<div class="container-image-pattern">
			</div>
		</div>
		<div class="col-9 column-form">
			<div class="container-headings">
				<div class="container-logo">
					<img src="https://img.qromo.io/img/logo.svg" alt="logo Qromo">
				</div>
				<div class="heading-form">
					<h1>{{ cardTitle }}</h1>
					<p>{{ cardBody }}</p>
				</div>
			</div>
			<div class="container-form">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>

import AppButton from "@/shared/components/AppButton.vue";
import {useLanguageStore} from "@/shared/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString};
	},
	name: "CardForm",
	components: {AppButton},
	emits: ['cta-click'],
	props: {
		cardTitle: {type: String, required: true},
		cardBody: {type: String, required: true},
		ctaExists: {type: Boolean, default: false},
		ctaText: {type: String, default: null},
		ctaDone: {type: Boolean, default: false}
	},
}
</script>

<style lang="scss" scoped>
.card-form {
	width: 100%;
	height: 100%;
	max-width: 960px;
	display: flex;
	background: #F9FAFD 0% 0% no-repeat padding-box;
	box-shadow: 0px 0px 45px #25529D4D;
	border-radius: 39px;
	overflow: hidden;
	@media(max-width: 620px) {
		flex-direction: column;
	}
	.container-image-pattern {
		position: relative;
		overflow: hidden;
		background-color: $primary;
		height: 100%;
		&:after {
			content: "";
			position: absolute;
			transform: rotate(-22deg);
			top: -50%;
			left: -50%;
			width: 400%;
			height: 350%;
			background-image: url(https://img.qromo.io/img/icon-repiter-image.svg);
			background-repeat: repeat;
			background-size: 200px;
			opacity: 0.6;
			@media(max-width: 620px) {
				height: 300%;
				top: -250%;
			}
		}
	}
	.container-headings {
		display: flex;
		padding-bottom: 20px;
		border-bottom: 1px solid $alpha_3;
		@media(max-width: 350px) {
			padding-bottom: 15px;
		}
		.heading-form {
			padding-left: 20px;
			width: 75%;
			@media(max-width: 320px) {
				padding-left: 12px;
			}
			h1 {
				text-align: left;
				font: normal normal 900 22px/27px Montserrat;
				color: #4E4E4E;
				@media(max-width: 450px) {
					font: normal normal 900 20px/23px Montserrat;
				}
				@media(max-width: 350px) {
					font: normal normal 900 18px/21px Montserrat;
				}
			}
			p {
				text-align: left;
				font: normal normal 400 12px/15px Montserrat;
				color: #4e4e4e;
				margin-top: 5px;
				@media(max-width: 350px) {
					font: normal normal 400 12px/15px Montserrat;
				}
			}
		}
	}
	.container-logo {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 60px;
		height: 60px;
		border-radius: 13px;
		border: 1px solid $primary;
		@media(max-width: 350px) {
			width: 50px;
			height: 50px;
		}
		img {
			width: 40px;
			height: 40px;
			@media(max-width: 350px) {
				width: 30px;
				height: 30px;
			}
		}
	}
	.container-form {
		padding: 30px 0 0 30px;
		margin-left: 30px;
		border-left: 1px solid $alpha_3;
		@media(max-width: 500px) {
			padding: 20px 0 0 20px;
			margin-left: 20px;
		}
		@media(max-width: 380px) {
			padding: 15px 0 0 0;
			margin-left: 0;
			border: none;
		}
	}
	.container-content {
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		transition: transform .5s $transition;
		img {
			height: auto;
			width: 100px;
			margin-bottom: 20px;
		}
		h2 {
			text-align: center;
			color: #0752a3;
			line-height: 32px;
			font-weight: 300;
		}
		@media(max-width: 620px) {
			height: 0;
			transform: translateY(-200px);
		}
	}
	.column-form {
		transform: translateX(-100%);
		padding: 50px;
		transition: transform .5s $transition;
		@media(max-width: 620px) {
			transform: translate(0);
		}
		@media(max-width: 500px) {
			padding: 30px;
		}
		@media(max-width: 350px) {
			padding: 20px;
		}
	}
	.pattern {
		transform: translateX(-300%);
		transition: transform .5s $transition;
		@media(max-width: 620px) {
			transform: translate(0);
		}
	}
	.col-3, .col-9 {
		@media(max-width: 620px) {
			flex: 0 0 100%;
			max-width: 100%;
		}
	}
	.col-3 {
		.container-image-pattern {
			@media(max-width: 620px) {
				min-height: 150px;
			}
			@media(max-width: 500px) {
				min-height: 120px;
			}
			@media(max-width: 400px) {
				min-height: 80px;
			}
			@media(max-width: 350px) {
				min-height: 60px;
			}
		}
	}

	.email-send {
		transform: translateX(-100%);
		flex: 0 0 75%;
		max-width: 75%;
		padding: 60px;
		display: flex;
		align-content: center;
		justify-content: center;
		transition: transform .5s $transition;
		@media(max-width: 620px) {
			transform: translate(0, -100%);
			flex: 0 0 100%;
			max-width: 100%;
			height: 0;
			padding: 0 30px;
			overflow: hidden;
		}
	}
	&.ctaDone {
		.email-send {
			transform: translateX(0);
			@media(max-width: 620px) {
				transform: translate(0);
				overflow: visible;
			}
		}
		.column-form {
			transform: translateX(0);
			@media(max-width: 620px) {
				transform: translate(0, 100%);
			}
		}
		.pattern {
			transform: translateX(0);
			@media(max-width: 620px) {
				transform: translate(0, 380%);
			}
			@media(max-width: 500px) {
				transform: translateY(425%);
			}
			@media(max-width: 400px) {
				transform: translateY(635%);
			}
			@media(max-width: 375px) {
				transform: translateY(667%);
			}
			@media(max-width: 360px) {
				transform: translateY(695%);
			}
			@media(max-width: 350px) {
				transform: translateY(785%);
			}
			@media(max-width: 333px) {
				transform: translateY(826%);
			}
			@media(max-width: 320px) {
				transform: translateY(786%);
			}
			@media(max-width: 282px) {
				transform: translateY(856%);
			}
			@media(max-width: 260px) {
				transform: translateY(878%);
			}
		}
		.container-content {
			@media(max-width: 620px) {
				transform: translateY(200px);
			}
			@media(max-width: 350px) {
				transform: translateY(120px);
			}
		}
	}
}
</style>